module.exports = function () {
  var html = "\n      <div class=\"zoom-overlay\" id=\"zoom-overlay\">\n        <div class=\"status\"></div>\n        <div class=\"controls\"></div>\n      </div>\n  ";
  return html;
};